import React from 'react';

function ErrorBanner({ error, onClose }) {
  if (!error) return null;
  return (
    <div className="alerta-rojo" style={{ marginBottom: 16 }}>
      <span className="alerta-rojo-icon">⚠️</span>
      <div>
        {error}
        {onClose && (
          <button
            style={{ marginLeft: 8, background: 'none', border: 'none', cursor: 'pointer', textDecoration: 'underline', color: 'inherit', minHeight: 'auto', padding: 0 }}
            onClick={onClose}
          >Cerrar</button>
        )}
      </div>
    </div>
  );
}

export default ErrorBanner;
